module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre_25",
    attrs: {
      "id": "filepos77846"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_c('a', {
    staticClass: "calibre8"
  }), _vm._v("10 "), _c('img', {
    staticClass: "calibre11",
    attrs: {
      "alt": "image",
      "src": "images/00004.jpg"
    }
  }), _vm._v(" Freedom - I")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Our freedom resides in mind, of which “ours” is the aspect we experience. Knowledge is unreal, or relative, but Understanding is real. We are free to understand if we can.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("But knowledge comes by reasoning, whereas understanding comes by intuition. It may be, however, that the knowledge obtained by reasoning can open the way for intuition, though to that end knowledge must be seen for what it is, that it is relative and not real.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("As a result of understanding we function on a different plane, little as it may effect the mode of life we enjoy. Above all we may come to perceive the futility of our struggle to impose the supposed desires of our “ego” on the inevitable. The Taoist injunction, taken over by Buddhism, to live in accordance with “nature” must mean just that.")])]), _vm._v(" "), _c('h3', {
    staticClass: "calibre_26",
    attrs: {
      "id": "filepos79070"
    }
  }, [_c('span', {
    staticClass: "calibre12"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("Freedom - II")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("The Maharshi also wrote on a piece of paper when a young man: “Whatever is destined not to happen will not happen, try as you may. Whatever is destined to happen will happen, do what you may to prevent it. This is certain.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("He was uncompromising in his teaching. His answer was: “Find out who it is who is predestined or has free-will.” More explicitly he said: “All the actions that the body is to perform are already decided upon at the time it comes into existence: the only freedom you have is whether or not to identify yourself with the body.” That means that in playing our part in the comedy in which we are given a role and which we call our life, we can identify ourselves with our role, really imagine we are the character whose part we are playing, or stand apart mentally and play it by sheer technique.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('a'), _vm._v("“All the actions "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the body is to perform")]), _vm._v(" are already decided upon at the time it comes into existence. . . .” The mind has a certain freedom, but not to decide the actions of the body. Its most valuable freedom is the liberty to understand and thereby to rid itself of its identifications and particularly of its illusion of individuality. When it has understood as much as that, it is at the disposition of Mind Itself and may awaken to Reality at any moment.")])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_35"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efb41cf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_020.vue
// module id = 120
// module chunks = 0